import { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { pageview } from "./utils/gtag";
import "./App.css";
import FormMockUp from "./pages/FormMockUpScreen";
import SuccessMockUp from "./pages/SuccessMockUpScreen";
import Form from "./pages/FormScreen";
import Success from "./pages/SuccessScreen";
import Payout from "./pages/PayoutScreen";
import Text from "./pages/TextScreen";

function Analytics() {
  const location = useLocation();

  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <Analytics />
      <Routes>
        <Route path="/" element={<FormMockUp />} />
        <Route path="/success" element={<SuccessMockUp />} />
        <Route path="/:id" element={<Form />} />
        <Route path="/:id/payout/:idtip" element={<Payout />} />
        <Route path="/:id/success/:idtip" element={<Success />} />
        <Route
          path="/politica-cookies"
          element={<Text id="679c9c22474dd68f9a1080d7" />}
        />
        <Route
          path="/politica-privacidad"
          element={<Text id="679c9bb4474dd68f9a1080c6" />}
        />
      </Routes>
    </Router>
  );
}

export default App;
